import Cookies from "js-cookie";
import VueRouter from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/course",
    // component: () => import("@/layouts/index.vue"),
    // children: [
    //   {
    //     path: "",
    //     component: () => import("@/views/index.vue"),
    //   },
    // ],
  },
  {
    path: "/adviser",
    redirect: "/course",
    // component: () => import("@/layouts/default.vue"),
    // children: [
    //   {
    //     path: "",
    //     component: () => import("@/views/adviser/index.vue"),
    //   },
    // ],
  },
  {
    path: "/certificate",
    redirect: "/course",
    // component: () => import("@/layouts/default.vue"),
    // children: [
    //   {
    //     path: "",
    //     component: () => import("@/views/certificate/index.vue"),
    //   },
    // ],
  },
  {
    path: "/collection",
    redirect: "/course",
    // component: () => import("@/layouts/default.vue"),
    // children: [
    //   {
    //     path: "",
    //     component: () => import("@/views/collection/index.vue"),
    //   },
    // ],
  },

  {
    path: "/course",
    component: () => import("@/layouts/default.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/course/index.vue"),
      },
    ],
  },
  {
    path: "/course/question/answer",
    component: () => import("@/layouts/index.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/course/question/answer/answer.vue"),
      },
    ],
  },
  {
    path: "/course/question/collect",
    component: () => import("@/layouts/index.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/course/question/collect/index.vue"),
      },
    ],
  },
  {
    path: "/course/question/details",
    component: () => import("@/layouts/index.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/course/question/details/index.vue"),
      },
    ],
  },
  {
    path: "/course/videos",
    component: () => import("@/layouts/index.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/course/videos/index.vue"),
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/layouts/index.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/login/index.vue"),
      },
    ],
  },
  {
    path: "/course/:id",
    component: () => import("@/layouts/detail.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/course/_id.vue"),
      },
    ],
  },
  {
    path: "/my/account",
    component: () => import("@/layouts/my.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/my/account/index.vue"),
      },
    ],
  },
  {
    path: "/my/address",
    component: () => import("@/layouts/my.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/my/address/index.vue"),
      },
    ],
  },
  {
    path: "/my/identity",
    component: () => import("@/layouts/my.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/my/identity/index.vue"),
      },
    ],
  },
  {
    path: "/my/info",
    component: () => import("@/layouts/my.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/my/info/index.vue"),
      },
    ],
  },

  {
    path: "/vip",
    component: () => import("@/layouts/default.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/vip/index.vue"),
      },
    ],
  },

  // {
  //   path: "/order",
  //   component: () => import("@/layouts/default.vue"),
  //   // component: () => import("@/layouts/index.vue"),
  //   children: [
  //     {
  //       path: "",
  //       component: () => import("@/views/order/index.vue"),
  //     },
  //   ],
  // },
  {
    path: "/plan",
    component: () => import("@/layouts/index.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/plan/index.vue"),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/layouts/error.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path === "/login") {
    next();
  } else {
    const token = Cookies.get("token");
    if (token) {
      next();
    } else {
      next("/login");
    }
  }
});

export default router;
